import { createStore } from "vuex";

const STORAGE_KEY = "vue-todo-pwa";

const defaultTodos = [
  { id: 1, text: "Learn JavaScript", done: true },
  { id: 2, text: "Learn Vue 3", done: true },
  { id: 3, text: "Learn Bootstrap 5", done: false },
  { id: 4, text: "Build something awesome!", done: false },
];

// initial state
const state = {

  isApp: (window.flutter_inappwebview?true:false),
  
  todos: JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || defaultTodos,

  cube:{
      showCube: false,    
      currentSide: null,
      expanded:false,
      expandedBackground: null,
      sides: [
            {
              id: 1,
              title: '<p>asdf</p>',
             // bgColor: 'background:#0078ca',
              /*'background: #fceabb; background: -webkit-linear-gradient(to right, #f8b500, #fceabb); background: linear-gradient(to right, #f8b500, #fceabb);',*/
             // bgImg:'https://cn.bing.com/th?id=OIP.yP8o0K-SfdQWgBdfCI_87wHaHf&pid=Api&rs=1&p=0',
              color:'#fff'
            },
            {
              id: 2,
              title: 'Friends',
             // bgColor: 'background:#0078ca',
             // bgColor: 'background: #FF8008;background: -webkit-linear-gradient(to bottom, #FFC837, #FF8008);background: linear-gradient(to bottom, #FFC837, #FF8008);',
              /*bgImg:'https://cn.bing.com/th?id=OIP.HgPJiE8XhY1ue-erO8gz6gHaHa&pid=Api&rs=1&p=0',*/
              color:'#fff'
            },
            {
              id: 3,
              title: 'Family',
              //bgColor: 'background:#0078ca',
              //bgColor: 'background: #FF416C;background: -webkit-linear-gradient(to bottom, #FF4B2B, #FF416C);background: linear-gradient(to bottom, #FF4B2B, #FF416C);',
              //bgImg: 'https://cn.bing.com/th?id=OIP.tHS8R0XNwzGUw42UM019GwHaHS&pid=Api&rs=1&p=0',
              color:'#fff'
            },
            {
              id: 4,
              title: 'Study',
            //  bgColor: 'background:#0078ca',
              //bgColor: 'background: #1D976C;background: -webkit-linear-gradient(to top, #93F9B9, #1D976C);background: linear-gradient(to top, #93F9B9, #1D976C);',
              /*bgImg:'https://cn.bing.com/th?id=OIP.aQy1TrGzC_n_UC0j9hXBbwHaIS&pid=Api&rs=1&p=0',*/
              color:'#fff'

            },
            {
              id:5,
              title: 'Duties',
              //bgColor: 'background:#0078ca',
             // bgColor: 'background: #00c6ff;background: -webkit-linear-gradient(to left, #0072ff, #00c6ff);background: linear-gradient(to left, #0072ff, #00c6ff);',
              /*bgImg:'https://cn.bing.com/th?id=OIP.PGP2WiIRMFWariYpAo2YIAHaIL&pid=Api&rs=1&p=0',*/
              color:'#fff'
            },
            {
              id:6,
              title: 'Health',
              //bgColor: 'background:#0078ca',
             // bgColor: 'background: #DA22FF;background: -webkit-linear-gradient(to bottom, #9733EE, #DA22FF);background: linear-gradient(to bottom, #9733EE, #DA22FF);',
              /*bgImg:'https://photos.gograph.com/thumbs/CSP/CSP992/healthy-living-wellness-lifestyle-clip-art-vector_k13396997.jpg',*/
              color:'#fff'

            },
        ],
    }
};

// mutations
const mutations = {
  addTodo(state, todo) {
    state.todos.push(todo);
  },

  removeTodo(state, todo) {
    state.todos.splice(state.todos.indexOf(todo), 1);
  },

  editTodo(state, { todo, text = todo.text, done = todo.done }) {
    const index = state.todos.indexOf(todo);

    state.todos.splice(index, 1, {
      ...todo,
      text,
      done,
    });
  },
};

// actions
const actions = {
  addTodo({ commit }, text) {
    commit("addTodo", {
      id: Date.now(),
      text,
      done: false,
    });
  },

  removeTodo({ commit }, todo) {
    commit("removeTodo", todo);
  },

  toggleTodo({ commit }, todo) {
    commit("editTodo", { todo, done: !todo.done });
  },

  editTodo({ commit }, { todo, value }) {
    commit("editTodo", { todo, text: value });
  },

  toggleAll({ state, commit }, done) {
    state.todos.forEach((todo) => {
      commit("editTodo", { todo, done });
    });
  },

  clearCompleted({ state, commit }) {
    state.todos
      .filter((todo) => todo.done)
      .forEach((todo) => {
        commit("removeTodo", todo);
      });
  },
};

// plugins
const plugins = [
  (store) => {
    store.subscribe((mutation, { todos }) => {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(todos));
    });
  },
];

export default createStore({
  state,
  mutations,
  actions,
  plugins,
});
